import React, { useEffect, useState } from "react";
import { Button } from 'elements';
import classes from "./addOption.module.scss";

import { ReactComponent as CloseIcon } from "./close.svg";

import { useDispatch } from "react-redux";

import { useLocation, useParams } from "react-router-dom";
import useWindowSize from "../../../../utils/useWindowSize";
import { AddOptionRows } from "redux/DecisionMatrix/AddOptionRows/action";
import { UpdateOption } from "redux/DecisionMatrix/UpdateOptions/action";

const AddOptionLink = ({
  value,
  setIsAddOptions,
  setIsAddCriteria,
  setIsAddLink,
  option,
  setOption,
  isShortList,
}) => {
  const { decisionId, optionId } = useParams();
  const [valueInput, setValue] = useState("");
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const { width } = useWindowSize();
  const dispatch = useDispatch();
  let { pathname } = useLocation();

  pathname = pathname.split("/");

  const isValidUrl = (string) => {
    try {
      const url = new URL(string);

      // Check if protocol is http or https
      if (url.protocol !== "http:" && url.protocol !== "https:") {
        return false;
      }

      // Check if there's a hostname (domain)
      if (!url.hostname) {
        return false;
      }

      // Check for a valid TLD (basic check)
      const tld = url.hostname.split(".").pop();
      if (tld.length < 2) {
        return false;
      }

      // Check if the original string matches the normalized protocol + "//"
      const expectedStart = `${url.protocol}//`;
      if (!string.startsWith(expectedStart)) {
        return false;
      }
      return true;
    } catch (error) {
      return false; // Invalid URL syntax
    }
  }

  useEffect(() => {
    if (value === "link") {
      setValue(option?.link || "");
    }
  }, [option]);

  const onClose = () => {
    if (value === "option") {
      setIsAddOptions(false);
    }
    if (value === "criteria") {
      setIsAddCriteria(false);
    }
    if (value === "link") {
      setIsAddLink(false);
    }
  };

  const onSave = (event) => {
    if (!error) {
      setError(false);

      if (value === "option") {
        dispatch(
          AddOptionRows({ num_rows: valueInput, decision_id: decisionId })
        );
      }

      if (value === "link") {
        dispatch(
          UpdateOption({ id: optionId, body: { link: valueInput } }, isShortList)
        );
        setOption({ ...option, link: valueInput });
        setIsAddLink(false);
      }
    } else {
      setError(true)
      event.preventDefault()
    }
  };

  const resetCustomValidity = event => {
    if (!event.target.value) {
      event.target.setCustomValidity('')
    }
  }

  const onChangeValue = e => {
    if (e.target.value.length == 0) {
      setErrorMessage("This field is required.")
      setValue(e.target.value)
      setError(true)
    }
    else if(e?.target?.value?.length > 2048) {
      setError(true)
      setErrorMessage("Link cannot be more than 2048 characters.")
      setValue(e.target.value)
    }
    else {
      let inputValue = e.target.value.trim();

      // Check if the input is a potential URL (contains a valid domain extension)
      const domainRegex = /\.(com|org|net|edu|gov|io|info|biz|us|co|uk)$/i;

      if (
        pathname.includes("option") &&
        domainRegex.test(inputValue) &&
        !/^https?:\/\//i.test(inputValue) // Check if it doesn't already have https
      ) {
        inputValue = `https://${inputValue}`;
      }

      if (!isValidUrl(inputValue)) {
        setError(true);
        setErrorMessage("Invalid URL format. Please enter a valid URL.");
      } else {
        setError(false);
        setErrorMessage("");
      }

      setValue(inputValue);
    }
  }

  return (
    <div className={classes.bg}>
      <form className={classes.wrapper} onSubmit={onSave}>
        <div className={classes.header}>
          <span>
            {option?.link ? "Edit" : "Add"} {value}
          </span>
          <button className={classes.close} type="button" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className={classes.body}>
          <div style={{ color: "black", marginBottom: "20px" }}>
            {value === "option"
              ? " No.of rows"
              : value === "criteria"
                ? ""
                : "Link"}
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <input
              value={valueInput}
              onChange={(e) => onChangeValue(e)}
              type={pathname.includes("option") ? "url" : "number"}
              max={5}
              min={1}
              // onInvalid={customValidityText}
              onInput={resetCustomValidity}
              placeholder={
                value === "option"
                  ? "Enter no. of options you want to add"
                  : value === "criteria"
                    ? "Enter criteria"
                    : "Enter URL of option"
              }
            />

            {error
              ? <span style={{ color: "red", marginLeft: "5px", fontSize: "15px" }}>{errorMessage}</span>
              : <span style={{ height: "24px" }}></span>}
          </div>
        </div>
        {width > 767 ? (
          <div className={classes.button}>
            <Button>Save</Button>
          </div>
        ) : (
          <div className={classes.buttonMob}>
            <Button>Save</Button>
          </div>
        )}
      </form>
    </div>
  );
};

export { AddOptionLink };
